import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('stp_user') || 'null'); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);
  const [authError, setAuthError] = useState(false);

  const loadMe = React.useCallback(() => {
    const token = localStorage.getItem('stp_token');
    if (!token) { setLoading(false); return; }
    setLoading(true); setAuthError(false);
    api.get('/auth/me').then((r) => {
      setUser(r.data);
      localStorage.setItem('stp_user', JSON.stringify(r.data));
    }).catch((err) => {
      const status = err?.response?.status;
      if (status === 401 || status === 403) {
        // Token genuinely invalid/expired → clear it so guards fall through to /login (not Client OS).
        localStorage.removeItem('stp_token');
        localStorage.removeItem('stp_user');
        setUser(null);
      } else {
        // Transient failure (network/5xx). Keep the cached coach session and flag an error so route
        // guards can offer a retry — a coach must NEVER be silently downgraded to a client here.
        setAuthError(true);
      }
    }).finally(() => setLoading(false));
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('stp_token', data.token);
    localStorage.setItem('stp_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };
  const signup = async (email, password, name) => {
    const { data } = await api.post('/auth/signup', { email, password, name });
    localStorage.setItem('stp_token', data.token);
    localStorage.setItem('stp_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem('stp_token');
    localStorage.removeItem('stp_user');
    setUser(null);
    window.location.href = '/login';
  };

  const updateAuth = ({ user: newUser, token } = {}) => {
    if (token) localStorage.setItem('stp_token', token);
    if (newUser) { localStorage.setItem('stp_user', JSON.stringify(newUser)); setUser(newUser); }
  };

  return <AuthCtx.Provider value={{ user, loading, login, signup, logout, updateAuth }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
